import React from 'react';
import Header from './header';
import LandingContent from './landingContent';
import Footer from "./footer";

const LandingPage = () => {
  return (
    <>
      <Header />
      <LandingContent />
      <Footer />
    </>
  )
}

export default LandingPage;